import React from 'react'
import { Form } from 'devextreme-react/form'
import type { ActionInput } from './types'

// dxForm only registers TextBox, NumberBox, CheckBox and DateBox on its own.
import 'devextreme/ui/text_area'
import 'devextreme/ui/select_box'

const formItem = (input: ActionInput) => {
	const label = input.label ?? input.name
	const editors = {
		select: {
			editorType: 'dxSelectBox',
			editorOptions: {
				items: (input.options ?? []).map(o => (typeof o === 'string' ? { value: o, text: o } : o)),
				valueExpr: 'value',
				displayExpr: 'text',
			},
		},
		textarea: { editorType: 'dxTextArea', editorOptions: { height: 110, placeholder: input.placeholder } },
		text: { editorType: 'dxTextBox', editorOptions: { placeholder: input.placeholder } },
	}
	const editor = (editors as Record<string, any>)[input.type ?? 'text'] ?? editors.text

	return {
		dataField: input.name,
		label: { text: label },
		...editor,
		validationRules: input.required ? [{ type: 'required', message: `${label} is required` }] : [],
	}
}

// Shown under the HTML body when an action needs inputs (e.g. Close without resolution).
// formData is a ref so DevExtreme can write into it.
export const ActionForm = React.forwardRef<any, { inputs: ActionInput[]; formData: Record<string, any> }>(
	({ inputs, formData }, ref) => (
		<Form
			ref={ref}
			formData={formData}
			items={inputs.map(formItem) as any}
			labelLocation="top"
			showColonAfterLabel={false}
		/>
	)
)

ActionForm.displayName = 'ActionForm'
